import { getRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";
import { CreateCupOfGratitudeDTO } from "utils/helpers/models/cup-gratitude/cup-gratitude.dto";


export const CUP_GRATITUDE_APIS = {
  uploadFile: (params: any) => postRequest("/file/upload", params),
  createCupOfGratitude: (body: CreateCupOfGratitudeDTO) =>postRequest(`/cup-of-gratitue`, body),
  getCupOfGratitude: (params: any) => getRequest(`/cup-of-gratitue`, params),
  editCupOfGratitudes: (id: number, params:any) => putRequest(`/cup-of-gratitue/${id}`, params),
  getCupOfGratitudesById: (id: number, ) => getRequest(`/cup-of-gratitue/${id}`),



};
